import React, { PureComponent } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { TTP_LOGO_URL, TTP_LOGO2_URL } from "Config";
import { selectUserCommunities } from "Selectors";
import { setNavCommunity, setAuthLoggedAs } from "Actions";
import { changeNavCommunity } from "Thunks";

import Community from "./Community";
import _ from "i18n";

export class SelectCommunity extends PureComponent {
  static defaultProps = {
    communities: []
  };

  static propTypes = {
    communities: PropTypes.array,
    setNavCommunity: PropTypes.func
  };

  componentDidUpdate() {
    const { user } = this.props;

    if (
      !user ||
      !user.role ||
      !user.role.organization ||
      !user.role.organization.owner
    ) {
      return null;
    }
    const {
      communities,
      setNavCommunity,
      changeNavCommunity,
      setAuthLoggedAs
    } = this.props;

    const { owner } = user.role.organization;

    let found = false;

    if (communities && communities.length > 0) {
      found =
        communities.filter(
          com => parseInt(com.portalOfficialActivated, 10) === 1
        ).length > 0;
    }

    if (!found) {
      setAuthLoggedAs("CLIENT");
      setNavCommunity(owner);
      changeNavCommunity(owner.id);
    }
  }

  handleSelectCommunity = community => {
    const {
      changeNavCommunity,
      setNavCommunity,
      setAuthLoggedAs,
      user
    } = this.props;
    const { owner } = user.role.organization;

    setAuthLoggedAs(owner ? "CLIENT" : "OFFICIAL");
    setNavCommunity(community);
    changeNavCommunity(community.id);
  };

  renderCommunities() {
    const { communities, user } = this.props;

    return communities.map(c => (
      <Community
        key={c.id}
        asCard={communities.length === 1}
        community={c}
        nbColumns={user.role.organization.owner ? 2 : 3}
        onClick={this.handleSelectCommunity.bind(this, c)}
      />
    ));
  }

  renderSimpleCommunities() {
    return (
      <div className="sc__container">
        <span className="sc__logo">
          <img src={TTP_LOGO_URL} alt="logo" />
        </span>
        <div className="sc__communities grid-x grid-margin-x">
          {this.renderCommunities()}
        </div>
      </div>
    );
  }

  renderCommunitiesWithOwner() {
    const { owner } = this.props.user.role.organization;

    return (
      <div className="sc__container">
        <div className="sc__logo">
          <img src={TTP_LOGO2_URL} alt="logo" />
        </div>
        <div className="grid-x sc__multi">
          <div className="cell sc__member small-12 medium-6">
            <i className="icon icon-people" />
            <h2>{_("Member access")}</h2>
            <div className="grid-x sc__com-contains grid-margin-x">
              {this.renderCommunities()}
            </div>
          </div>
          <div className="cell sc__client small-12 medium-6">
            <i className="icon icon-briefcase" />
            <h2>{_("Access as client")}</h2>
            <div className="grid-x sc__com-contains">
              <Community
                key={owner.id}
                nbColumns={2}
                community={owner}
                asCard={true}
                onClick={this.handleSelectCommunity.bind(this, owner)}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { user } = this.props;
    if (!user) {
      return null;
    }
    const { owner } = user.role.organization;
    const hasOwner = owner && owner.id;
    return (
      <div id={hasOwner ? "has__owner" : "select-community"}>
        {hasOwner
          ? this.renderCommunitiesWithOwner()
          : this.renderSimpleCommunities()}
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  communities: selectUserCommunities(state),
  user: state.auth.user
});

const mapDispatchToProps = dispatch => ({
  setNavCommunity: community => dispatch(setNavCommunity(community)),
  setAuthLoggedAs: accessType => dispatch(setAuthLoggedAs(accessType)),

  changeNavCommunity: communityId => dispatch(changeNavCommunity(communityId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectCommunity);



// WEBPACK FOOTER //
// ./src/components/SelectCommunity/SelectCommunity.js